import {useRef} from "react";
import Accordion from "./Accordion";

const CareerCard = ({
                        title,
                        responsibilities,
                        mustknow,
                        isOpen,
                        onClick,
                        err
                    }) => {
    const cardRef = useRef(null);
    const contentRef = useRef(null);

    if (err) {
        return (
            <article className="career__card flex col w-100 mt-16">
                <p className="white text-center">{err}</p>
            </article>
        );
    }

    return (
        <article ref={cardRef} className="career__card flex col w-100 mt-16">
            <h2
                className={`main__color accordion-trigger ${isOpen ? "open" : ""}`}
                onClick={onClick}
            >
                {title}
                <span className="accordion-arrow"/>
            </h2>

            <div
                ref={contentRef}
                className={`accordion ${isOpen ? "open" : ""}`}
                style={{
                    maxHeight: isOpen
                        ? `${contentRef.current?.scrollHeight}px`
                        : "0px",
                }}
            >
                <div className="accordion-inner">
                    {responsibilities?.li && (
                        <Accordion title="Responsibilities" obj={responsibilities}/>
                    )}
                    {mustknow?.li && (
                        <Accordion title="Must Know / Be Able To" obj={mustknow}/>
                    )}
                </div>
            </div>
        </article>
    );
};

export default CareerCard;
